import React, { useState, useEffect } from "react";
import Masters_header from './Masters_header';
import "../../styles/RoleMaster.css";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import down_arrow from "../../assets/svg/down_arrow.svg";
import { useNavigate } from 'react-router-dom';
import axiosInstance from "../../axiosInstance";
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import CommonFooter from "../../CommonFooter/CommonFooter";

const RoleMaster = () => {

  let ModuleId = 3
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);
  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [skip, setSkip] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;


  // Fetch roles from API
  const fetchRoles = async (term = '') => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get('/role/list', {
        params: {
          limit,
          skip: currentPage * limit,
          search: term || ''
        }
      });
      if (response.data && Array.isArray(response.data.role)) {
        setTableData(response.data.role);
        setTotalCount(response.data.totalCount || response.data.role.length);
      }
    } catch (error) {
      toast.error("Failed to fetch roles");
      console.error("Error fetching roles:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles(searchTerm);
  }, [currentPage, limit]);

  const handleAddNewClick = () => {
    navigate("/roleCreation");
  };

  const handleSelectAll = () => {
    if (tableData.length === 0) return;
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handlePageClick = ({ selected }) => {
    const newSkip = selected * limit;
    setCurrentPage(selected);
    setSkip(newSkip);
    setSelectedRows([]);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const handleDeleteRole = (roleId) => {
    setDeleteId(roleId);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      await axiosInstance.delete(`/role/delete/${deleteId}`);
      toast.success("Role deleted successfully");
      fetchRoles();
    } catch (error) {
      toast.error("Failed to delete role");
      console.error("Error deleting role:", error);
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };


  const handleEditClick = async (roleId) => {
    try {
      const response = await axiosInstance.get(`/role/edit/${roleId}`);
      if (response.data) {
        // Navigate to role creation page with edit data
        navigate('/roleCreation', {
          state: {
            editData: response.data,
            roleId,
            isEdit: true
          }
        });
      } else {
        toast.error("No data received for this role");
      }
    } catch (error) {
      toast.error("Failed to fetch role details");
      console.error("Error fetching role:", error);
    }
  };

  const handleCloneClick = async (roleId) => {
    try {
      const response = await axiosInstance.get(`/role/edit/${roleId}`);
      if (response.data) {
        navigate('/roleCreation', {
          state: {
            cloneData: response.data,
            isClone: true,
          }
        });
      } else {
        toast.error("No data received for this role");
      }
    } catch (error) {
      toast.error("Failed to fetch role details for cloning");
      console.error("Error cloning role:", error);
    }
  };

  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchRoles(term);
  };


  return (
    <>
      <Masters_header onSearch={handleSearch} />
      <div className="container">
        <div className="header d-flex justify-content-between">
          <h3>Role Master: {totalCount}</h3>

          <PermissionWrapper permissionKey="create_permission" moduleId={ModuleId}>
            {!isAnySelected && (
              <button id="addNewBtn" onClick={handleAddNewClick}>Add New</button>
            )}
          </PermissionWrapper>

        </div>

        <div className="user-table" style={{ overflowX: 'auto', scrollBehavior: 'smooth' }}>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Code</th>
                <th>Role Name</th>
                <th>Designation</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row, index) => (
                <tr key={row.id}>
                  <td>{currentPage * limit + index + 1}</td>
                  <td>{row.role_code}</td>
                  <td>{row.role_name}</td>
                  <td> {row.designations}</td>
                  <td>
                    <div className="actions" style={{ gap: '10px' }}>
                      <span
                        className="edit-icon"
                        title="Clone"
                        style={{
                          cursor: 'pointer',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          backgroundColor: '#fff',
                        }}

                        onClick={() => handleCloneClick(row.id)}
                      >
                        <svg width="15" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 15C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12C12.9319 2 13.3978 2 13.7654 2.15224C14.2554 2.35523 14.6448 2.74458 14.8478 3.23463C15 3.60218 15 4.06812 15 5M12.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V12.2C22 11.0799 22 10.5198 21.782 10.092C21.5903 9.71569 21.2843 9.40973 20.908 9.21799C20.4802 9 19.9201 9 18.8 9H12.2C11.0799 9 10.5198 9 10.092 9.21799C9.71569 9.40973 9.40973 9.71569 9.21799 10.092C9 10.5198 9 11.0799 9 12.2V18.8C9 19.9201 9 20.4802 9.21799 20.908C9.40973 21.2843 9.71569 21.5903 10.092 21.782C10.5198 22 11.0799 22 12.2 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      </span>

                      <PermissionWrapper permissionKey="edit_permission" moduleId={ModuleId}>
                        <span
                          className="edit-icon"
                          title="Edit"
                          style={{
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            backgroundColor: '#fff',
                          }}
                          onClick={() => handleEditClick(row.id)}
                        >
                          <img src={Vector} alt="Edit" width="14" height="14" />
                        </span>
                      </PermissionWrapper>


                      <PermissionWrapper permissionKey="delete_permission" moduleId={ModuleId}>
                        <span
                          className="delete-icon"
                          title="Delete"
                          style={{
                            cursor: 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                            backgroundColor: '#fff',
                          }}
                          onClick={() => handleDeleteRole(row.id)}
                        >
                          <img src={Delete} alt="Delete" width="27" height="27" />
                        </span>
                      </PermissionWrapper>

                      </div>
                    </td>
                  </tr>
                ))) : (
                <tr>
                  {searchTerm && tableData.length === 0 && (
                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                      No Role found matching "{searchTerm}"
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>

        </div>

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel="Previous"
              nextLabel="Next"
              pageCount={Math.ceil(totalCount / limit)}
              onPageChange={handlePageClick}
              forcePage={currentPage}
              containerClassName="pagination"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              disabledClassName="disabled"
            />
          </div>
        </div>
      </div>
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this Role?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default RoleMaster;